import { conns } from '@cfg/axiosConfig.tsx';

import type {
  Customer,
  CustomerCreatePayload,
} from '@store/slices/posCustomersSlice.tsx';

export type PosCustomer = Customer;

export const searchPosCustomers = async (query: string): Promise<Customer[]> => {
  const trimmed = query.trim();
  if (!trimmed) {
    return [];
  }
  const { data } = await conns<Customer[]>('erp:customers:search').get({ q: trimmed });
  return data;
};

export const fetchPosCustomer = async (customerId: number): Promise<Customer> => {
  const { data } = await conns<Customer>('erp:customers:detail', [customerId]).get();
  return data;
};

export const createPosCustomer = async (
  payload: CustomerCreatePayload,
): Promise<Customer> => {
  const { data } = await conns<Customer>('erp:customers:create').post(payload);
  return data;
};
